import React, { Component } from 'react'

import './Modes.scss'
import IconSVG from 'svg-inline-react'

class Modes extends Component {

    static propTypes = {
        containerClassName: React.PropTypes.string,
    }

    render() {

        return (
            <div className="Modes">
                <div className={this.props.containerClassName || "container"}>
                    <div className="Modes-title">Как работает Везёт&nbsp;Всем</div>
                    <div className="Modes-block Modes-titleBlock">
                        <div className="Modes-prosAndConsTitle Modes-simpleCard"></div>
                        <div className="Modes-prosAndCons Modes-simpleCard">
                            <div className="Modes-modeTitle">Аукцион</div>
                            <div className="Modes-modeSubTitle">Стандартный режим</div>
                        </div>
                        <div className="Modes-prosAndCons Modes-simpleCard">
                            <div className="Modes-modeTitle">Календарь</div>
                            <div className="Modes-modeSubTitle">Новый режим для Москвы и Московской&nbsp;области</div>
                        </div>
                    </div>
                    <div className="Modes-block">
                        <div className="Modes-card Modes-prosAndConsTitle">
                            <IconSVG
                                className="Modes-icon"
                                src={require(`!svg-inline!../InstantBookingSpinner/money.svg`)}
                            />
                            Стоимость перевозки
                        </div>
                        <div className="Modes-prosAndCons Modes-card">
                            <div className="Modes-stick">✓</div>
                            <div className="Modes-cardText">
                                <p>Благодаря системе торгов, достигается максимально выгодная цена</p>
                                <p>Цена окончательна, без почасовых расчётов и&nbsp;скрытых комиссий</p>
                            </div>
                        </div>
                        <div className="Modes-prosAndCons Modes-card">
                            <div className="Modes-stick">✓</div>
                            <div className="Modes-cardText">
                                <p>Такая&nbsp;же выгодная цена, как и&nbsp;на&nbsp;аукционе.</p>
                                <p>За&nbsp;6&nbsp;лет мы&nbsp;провели более 43&nbsp;811 аукционов по&nbsp;подобным условиям.</p>
                                <p>Цена окончательна, без почасовых расчётов и&nbsp;скрытых комиссий</p>
                            </div>
                        </div>
                    </div>
                    <div className="Modes-block">
                        <div className="Modes-card Modes-prosAndConsTitle">
                            <IconSVG
                                className="Modes-icon Modes-iconTrucks"
                                src={require(`!svg-inline!../InstantBookingSpinner/trucks.svg`)}
                            />
                            Выбор исполнителя
                        </div>
                        <div className="Modes-prosAndCons Modes-card">
                            <div className="Modes-cross">x</div>
                            <div className="Modes-cardText">
                                <p>Самостоятельный, после предварительного общения с&nbsp;перевозчиком</p>
                                <p>Требует вашего времени</p>
                            </div>
                        </div>
                        <div className="Modes-prosAndCons Modes-card">
                            <div className="Modes-stick">✓</div>
                            <div className="Modes-cardText">Вы&nbsp;заказываете перевозку в&nbsp;1&nbsp;клик, а&nbsp;мы&nbsp;назначаем подходящую машину и&nbsp;водителя</div>
                        </div>
                    </div>
                    <div className="Modes-block">
                        <div className="Modes-card Modes-prosAndConsTitle">
                            <IconSVG
                                className="Modes-icon"
                                src={require(`!svg-inline!../InstantBookingSpinner/shield.svg`)}
                            />
                            Время и надежность
                        </div>
                        <div className="Modes-prosAndCons Modes-card">
                            <div className="Modes-stick">✓</div>
                            <div className="Modes-cardText">
                                <p>Все обговоренные с&nbsp;перевозчиком детали перевозки фиксируются в&nbsp;гарантийном бланке заказа</p>
                                <p>Везёт&nbsp;Всем выступает гарантом неизменности цены и&nbsp;условий</p>
                            </div>
                        </div>
                        <div className="Modes-prosAndCons Modes-card">
                            <div className="Modes-stick">✓</div>
                            <div className="Modes-cardText">
                                <p>Отсутствие переписки с&nbsp;перевозчиком экономит ваше время</p>
                                <p>Все детали фиксируются в&nbsp;договоре на&nbsp;перевозку</p>
                                <p>Бесплатное страхование груза со&nbsp;страховым покрытием 100&nbsp;000&nbsp;₽, даже Б/У грузов</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Modes



// WEBPACK FOOTER //
// ./client/components/Modes/Modes.js